<template>
  <div>
    <v-row v-if="loading" align="center" justify="center" no-gutters style="min-height: 80px">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-row>
    <v-card v-else-if="siteVpn" flat>
      <v-data-list>
        <v-data-list-item>
          <v-data-list-label>Status</v-data-list-label>
          <v-data-list-text>
            <v-chip
              v-if="vpnUser"
              :color="!vpnUser.status ? 'error' : vpnUser.disabled ? 'grey lighten-2' : 'success'"
              small
            >
              {{ !vpnUser.status ? 'Offline' : vpnUser.disabled ? 'Disabled' : 'Online' }}
            </v-chip>
          </v-data-list-text>
        </v-data-list-item>
        <v-data-list-item>
          <v-data-list-label>Virtual IP</v-data-list-label>
          <v-data-list-text>
            {{ siteVpn.address }}
          </v-data-list-text>
        </v-data-list-item>
        <v-data-list-item v-if="vpnUser">
          <v-data-list-label>Real IP</v-data-list-label>
          <v-data-list-text>
            <template v-if="vpnUser.servers[0].real_address">
              {{ vpnUser.servers[0].real_address }}
            </template>
            <span v-else class="grey--text">Not available</span>
          </v-data-list-text>
        </v-data-list-item>
        <v-data-list-item v-if="vpnUser">
          <v-data-list-label>Device</v-data-list-label>
          <v-data-list-text class="text-capitalize">
            <template v-if="vpnUser.servers[0].device_name">
              {{ vpnUser.servers[0].device_name }}
            </template>
            <span v-else class="grey--text">Not available</span>
          </v-data-list-text>
        </v-data-list-item>
      </v-data-list>

      <v-card-text> </v-card-text>
    </v-card>
  </div>
</template>
<script>
import fetch from '@/utils/fetch'

export default {
  name: 'SiteVpnCard',
  props: {
    siteVpn: {
      type: Object,
      required: true
    },
    site: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      vpnUser: null,
      loading: false,
      error: null,
      fileLoading: false,
      statusLoading: false,
      newAlias: '',
      tab: null,
      organization: null
    }
  },

  mounted() {
    this.getVpnUser()
    this.getOrganization()
  },

  methods: {
    getOrganization() {
      fetch(this.site.organization['@id'])
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.organization = data
        })
        .catch(e => {
          this.error = e
        })
    },
    async getVpnUser() {
      this.loading = true
      fetch(`${this.siteVpn['@id']}/vpn/user`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.vpnUser = data
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.loading = false
        })
    },

    toggleEnabled(vpnUser, value) {
      const endpoint = value ? 'enable_user' : 'disable_user'
      this.statusLoading = true
      fetch('/site_vpns/' + vpnUser.name + '/vpn/' + endpoint, {
        method: 'PUT',
        body: JSON.stringify({})
      })
        .then(response => {
          return response.json()
        })
        .then(() => {
          this.getVpnUser()
        })
        .catch(e => {
          this.error = e
        })
        .finally(() => {
          this.statusLoading = false
        })
    }
  }
}
</script>
